import AuthHttpService from "./AuthHttpService";

export default class BoostService extends AuthHttpService {
  public constructor(readonly url?: string) {
    super(url);
  }

  async addProfileClick(params: { campaignId: string; pathname: string }): Promise<void> {
    const { campaignId, pathname } = params;
    return await this.post(`v2/boost/campaigns/${campaignId}/profile_click`, {
      source: pathname
    });
  }
}
